import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from 'primereact/toast';
import BeatLoader from "react-spinners/BeatLoader";
import { Dialog } from 'primereact/dialog';
import { FaBuilding, FaEye, FaEyeSlash, FaUser } from "react-icons/fa";
import AuthService from "../../modules/Admin/services/AuthService";

const API_URL = process.env.REACT_APP_API_URL;
const otherUrl = process.env.REACT_APP_OTHER_URL;

const Roles = {
  SuperAdmin: 1,
  Admin: 2,
  Manager: 3,
  Employee: 4,
};

function LoginForm() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false); 
  const toast = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [footerVisible, setFooterVisible] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    const { email: savedEmail, password: savedPassword } = AuthService.getRememberedCredentials();
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);

    setTimeout(() => {
      AuthService.login(email, password, rememberMe, navigate, Roles)
        .then(() => {         
        })
        .catch((err) => {
          if (toast.current) {
            toast.current.show({
              severity: 'error',
              summary: 'Invalid Username or Password',
              detail: 'Please enter a valid username or password.',
              life: 3000
            });
          }
          console.error('Login failed', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 2000);
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
       <Toast ref={toast} />
         <main class="main-content  mt-0">
            <div class="page-header align-items-start min-vh-100" >
              <span class="mask bg-gradient-dark opacity-6"></span>
              <div class="container my-auto">
                <div class="row">
                  <div class="col-lg-4 col-md-8 col-12 mx-auto">
                    <div class="card z-index-0 fadeIn3 fadeInBottom">
                      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                        <div class="bg-gradient-dark shadow-dark border-radius-lg py-3 pe-1">
                          <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">Sign in</h4>
                        </div>
                      </div>
                      <div class="card-body">
                        <form role="form" class="text-start" onSubmit={handleSubmit}>
                          <div class="input-group input-group-outline my-3">
                            <label class="form-label">Email</label>
                            <input value={email} onChange={(e) => setEmail(e.target.value)} type="text"  className="form-control" id="username" name="username" required />
                          </div>
                          <div class="input-group input-group-outline mb-3">
                            <label class="form-label">Password</label>
                            <input  value={password}  onChange={(e) => setPassword(e.target.value)}  type={showPassword ? 'text' : 'password'}
                            className="form-control" id="password"  name="password" required  />
                          </div>
                          <div class="form-check form-switch d-flex align-items-center mb-3">
                            <input class="form-check-input" type="checkbox" id="rememberMe" checked/>
                            <label class="form-check-label mb-0 ms-3" for="rememberMe">Remember me</label>
                          </div>
                          <div class="text-center">
                            <button type="submit" class="btn bg-gradient-dark w-100 my-4 mb-2">Sign in</button>
                          </div>
                          <p class="mt-4 text-sm text-center">
                            Don't have an account?
                            <a href="../pages/sign-up.html" class="text-primary text-gradient font-weight-bold">Sign up</a>
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
       </main>
     </div>
  );
}

export default LoginForm;
